import React, { useState, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import Modal from '../../../components/modal';
import Button from '../../../components/Button';
import { toast } from 'react-toastify';
import { FaStar } from 'react-icons/fa';

// StarRating Component
const StarRating = ({ rating, setRating }) => {
  return (
    <div className="flex">
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        return (
          <label key={index}>
            <input
              type="radio"
              name="rating"
              value={ratingValue}
              onClick={() => setRating(ratingValue)}
              className="hidden"
            />
            <FaStar
              className="cursor-pointer"
              color={ratingValue <= rating ? '#ffc107' : '#e4e5e9'}
              size={25}
            />
          </label>
        );
      })}
    </div>
  );
};

// Reviews Component
const Reviews = ({ isModalOpen, setIsModalOpen, closeModal, signalId,setCourseDetails}) => {
  const [studentId, setStudentId] = useState('');
  const [reviewData, setReviewData] = useState({
    reviewText: '',
    rating: 0
  });
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    const storedAdminData = localStorage.getItem('userData');
    if (storedAdminData) {
      const admin = JSON.parse(storedAdminData);
      setStudentId(admin?._id);
    } else {
      console.log('No admin data found in local storage.');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReviewData({ ...reviewData, [name]: value });

    if (value.trim() !== '') {
      setValidationError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (reviewData.reviewText.trim() === '') {
      setValidationError('Review is required');
      return;
    }

    setLoading(true);

    const payload = {
      enrollmentId: signalId,
      studentId: studentId,
      reviewText: reviewData.reviewText,
      rating: reviewData.rating
    };

    try {
      const response = await fetch('https://quran-backend-theta.vercel.app/v1/user/review', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data?.success) {
        toast.success(data.message);
        setCourseDetails();
        setIsModalOpen(false)
        window.location.reload();  
      } else {
        toast.error(data.message);
        // setCourseDetails();
        // setIsModalOpen(false)
        // window.location.reload();
      
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // setCourseDetails();
      // setIsModalOpen(false)
      // window.location.reload();
      
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = reviewData.reviewText.trim() !== '' && reviewData.rating > 0;

  return (
    <Modal isOpen={isModalOpen} onClose={closeModal} className="rounded-md">
      <div>
        <div className="p-3 flex justify-between items-center">
          <div></div>
          <h1 className="capitalize h4 font-medium">Add Review</h1>
          <MdClose className="cursor-pointer" onClick={() => setIsModalOpen(false)} size={25} />
        </div>
        <hr />
        <div className="p-5">
          <form onSubmit={handleSubmit}>
            <div className="flex gap-5 flex-wrap">
              <div className="w-full flex justify-center">
                <StarRating
                  rating={reviewData.rating}
                  setRating={(rating) => setReviewData({ ...reviewData, rating })}
                />
              </div>
              <div className="w-full">
                <label>Your Review</label>
                <textarea
                  name="reviewText"
                  placeholder="Write Review About Customer"
                  className="bg-gray-100 mt-3 outline-none rounded-md p-2 w-full"
                  value={reviewData.reviewText}
                  onChange={handleChange}
                  rows={5}
                />
              </div>
            </div>
            {validationError && <p className="text-red text-sm mt-1">{validationError}</p>}
            <div className="w-64 mx-auto mt-5">
              {loading ? (
                <button
                  disabled
                  type="button"
                  className="bg-[#FB5722] w-full text-center mt-3 py-2.5 rounded-lg text-white uppercase font-semibold cursor-pointer"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                  Loading...
                </button>
              ) : (
                <div className="flex justify-center">
                  <Button
                    label="Submit"
                    type="submit"
                    className={`mt-3 py-2.5 w-full ${
                      !isFormValid
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-secondary cursor-pointer'
                    } text-white uppercase font-semibold rounded-lg`}
                    disabled={!isFormValid}
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default Reviews;
